import { RootState } from 'common/redux'
import { UUID } from 'common/types'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { useSessionMode } from 'session-mode/use-session-mode'
import ConfiguredKnowledgeCheckReviewTrainer from './configured-knowledge-check-review-trainer'
import ConfiguredKnowledgeCheckTrainer from './configured-knowledge-check-trainer'
import { KnowledgeCheckTrainerLayout } from './knowledge-check'

const ConfiguredKnowledgeCheckViewTrainer: FC<{
	knowledgeCheckId: UUID
}> = ({ knowledgeCheckId }) => {
	const isReview = useSelector(
		(state: RootState) => state.knowledgeChecks.isReview
	)
	// In person the check is the whole stage, in two panes; online it is a card
	// among the video columns.
	const layout: KnowledgeCheckTrainerLayout =
		useSessionMode() === 'IN_PERSON' ? 'two-pane' : 'card'
	return !isReview ? (
		<ConfiguredKnowledgeCheckTrainer
			knowledgeCheckId={knowledgeCheckId}
			layout={layout}
		/>
	) : (
		<ConfiguredKnowledgeCheckReviewTrainer
			knowledgeCheckId={knowledgeCheckId}
			layout={layout}
		/>
	)
}

export default ConfiguredKnowledgeCheckViewTrainer
